import { Identifier } from "react-admin";

import { Space } from "./spaces";
import { ColumnsOf } from "../data";
import { AnyString, Maybe } from "../utility";

export type Role = "admin" | "writer" | "reader";

export const permitStatus = {
  Active: "active",
  Inactive: "inactive",
  Exhausted: "exhausted"
} as const;

export type PermitStatus = (typeof permitStatus)[keyof typeof permitStatus];

export type AppMode =
  | "luna.default"
  | "luna.minimal"
  | "luna.history"
  | "luna.no_interaction"
  | AnyString;

export interface Permit {
  id: Identifier;
  name: Maybe<string>;
  max_profiles: Maybe<number | string>;
  num_profiles: Maybe<number>;
  config: Maybe<unknown>;
  tags: Maybe<string[]>;
  created_at: string;
  created_by: Maybe<string>;
  space_id: Identifier;
  spaces: Space;
  allows: Identifier[];
  role: Role;
  tracker: boolean;
  status: PermitStatus;
  link: string;
  expires_at: string;

  app_mode: AppMode;

  finder_on: boolean;

  gateway_on: boolean;
  send_gateway_name: boolean;
  location_on: boolean;

  tracker_on: boolean;
}

export type PermitInsert = Pick<
  Permit,
  | "name"
  | "max_profiles"
  | "space_id"
  | "allows"
  | "role"
  | "app_mode"
  | "finder_on"
  | "gateway_on"
  | "send_gateway_name"
  | "location_on"
  | "tracker_on"
  | "tags"
>;

export const PERMIT_COLUMNS: ColumnsOf<Permit> = ["*", "spaces(*)"];
